import {
  type Datatype,
  type PlainDatatype,
} from '@framework/engine/schema/expressions/datatype/Datatype.ts';
import {
  type IReference,
  type ReferenceType,
} from '@framework/engine/schema/expressions/references/IReference.ts';
import { ReferencePathDirection } from '@framework/engine/schema/expressions/references/IReferencePath.ts';

/**
 * Crea una reference per i soggetti (titolare, richiedente, etc.)
 */
export function createSubjectReference(props: {
  datatype: PlainDatatype | Datatype.File;
  code: string;
  prefixLabel: string;
  label: string;
  idPrefix: string;
  referenceType: ReferenceType;
  referenceSubtype: string;
  group: string;
}): IReference {
  const {
    datatype,
    code,
    prefixLabel,
    label,
    idPrefix,
    referenceType,
    group,
    referenceSubtype,
  } = props;

  return {
    type: referenceType,
    id: getSubjectReferenceId(idPrefix, code),
    code,
    label: `${prefixLabel}: ${label}`,
    path: [
      { direction: ReferencePathDirection.Absolute, code: referenceType },
      {
        direction: ReferencePathDirection.Child,
        code: referenceSubtype,
      },
    ],
    field: {
      type: datatype,
    },
    group,
  };
}

export function getSubjectReferenceId(prefix: string, code: string): string {
  return `${prefix}_${code}`;
}

export interface ISubjectReferenceStructure {
  datatype: Datatype.String | Datatype.Number | Datatype.Date | Datatype.File;
  code: string;
  label: string;
}
